import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { Field, sel, todayIso, useAccounts, AccLabel, accColor } from "@/lib/finance";

// v1.37.1 Konum Değiştir (tekli/toplu): yalnız fiziksel yer; muhasebe/cari etkisi yok. Tahsile vermeden ("Banka (Tahsile Ver)") farklıdır.
export default function KonumDialog({ ids, target, onClose, onDone }) {
  const banks = useAccounts().filter((a) => a.type === "banka");
  const [f, setF] = useState({ account_id: "", date: todayIso(), note: "" });
  const [busy, setBusy] = useState(false);
  const toKasa = target === "banka_kasasi";
  const acc = f.account_id || banks[0]?.id || "";
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/cek-senet/konum", { ids, konum: target, account_id: toKasa ? acc : null, date: f.date, note: f.note || null });
      toast.success(`${data.moved.length} evrak ${toKasa ? "banka kasasına konuldu" : "şirkete alındı"}${data.skipped.length ? ` · ${data.skipped.length} zaten bu konumda` : ""}`);
      onDone();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="konum-dialog">
        <DialogHeader><DialogTitle>{toKasa ? "Banka Kasasına Koy (Emanet)" : "Şirkete Al"} · {ids.length} evrak</DialogTitle></DialogHeader>
        <p className="text-[12px] text-slate-600">{toKasa ? "Evrak bankanın kiralık kasasında saklanır; TAHSİLE VERİLMEZ. Durum \"Portföyde\" kalır, muhasebe ve cari etkisi yoktur." : "Evrak fiziksel olarak ofise alınır. Durum \"Portföyde\" kalır."}</p>
        <div className="grid grid-cols-2 gap-3">
          {toKasa && <Field label={<AccLabel text="Banka" color={accColor(banks, acc)} />} className="col-span-2">
            <select className={`${sel} w-full`} value={acc} onChange={(e) => setF({ ...f, account_id: e.target.value })} data-testid="konum-bank">{banks.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></Field>}
          <Field label="Tarih"><Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="konum-date" /></Field>
          <Field label={toKasa ? "Not / kasa no" : "Not"}><Input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="konum-note" /></Field>
        </div>
        <DialogFooter><Button disabled={busy || (toKasa && !acc)} onClick={go} data-testid="konum-submit">{toKasa ? "Banka Kasasına Koy" : "Şirkete Al"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export const KonumBadge = ({ i, testid }) => i.status !== "portfoyde" ? null : i.konum === "banka_kasasi"
  ? <span className="inline-flex items-center gap-1 rounded border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[11px] text-amber-800" data-testid={testid}>
      <span className="h-2 w-2 rounded-full" style={{ background: i.konum_color || "#64748b" }} />Banka Kasası{i.konum_account_name ? ` · ${i.konum_account_name}` : ""}</span>
  : <span className="rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[11px] text-blue-700" data-testid={testid}>Şirkette</span>;
